import React from "react";
// mui
import { Card, Typography, Grid, Box, Skeleton } from "@mui/material";

export const Summary = ({ summaryData, role }) => {
  const UserMultipleIcon = "/Assets/Icons/user-multiple.svg";
  const isSuper = role === "Super-User";

  const fmt = (v) => Number(v || 0).toFixed(2);
  const sum = (...vals) => vals.reduce((a, b) => a + (Number(b) || 0), 0);

  // 4 cards (as-is) for Super-User
  const asIsData = [
    {
      id: 1,
      name: "Tada - Total Bet Amount",
      value: fmt(summaryData?.tadaBetAmount),
      icon: UserMultipleIcon,
      color: "#18DC8B",
    },
    {
      id: 2,
      name: "Tada - Total Win Amount",
      value: fmt(summaryData?.tadaWinAmount),
      icon: UserMultipleIcon,
      color: "#18DC8B",
    },
    {
      id: 3,
      name: "Vegas - Total Bet Amount",
      value: fmt(summaryData?.vegasBetAmount),
      icon: UserMultipleIcon,
      color: "#18DC8B",
    },
    {
      id: 4,
      name: "Vegas - Total Win Amount",
      value: fmt(summaryData?.vegasWinAmount),
      icon: UserMultipleIcon,
      color: "#18DC8B",
    },
  ];

  // 2 cards (combined) for non-Super users
  const combinedData = [
    {
      id: "bet",
      name: "Total Bet Amount",
      value: fmt(
        sum(summaryData?.tadaBetAmount, summaryData?.vegasBetAmount)
      ),
      icon: UserMultipleIcon,
      color: "#18DC8B",
    },
    {
      id: "win",
      name: "Total Win Amount",
      value: fmt(sum(summaryData?.tadaWinAmount, summaryData?.vegasWinAmount)),
      icon: UserMultipleIcon,
      color: "#18DC8B",
    },
  ];

  const data = isSuper ? asIsData : combinedData;
  const skeletonCount = isSuper ? 4 : 2;

  return (
    <React.Fragment>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        {summaryData === null ? (
          <>
            {[...Array(skeletonCount)].map((_, index) => (
              <Grid item xs={12} sm={6} md={isSuper ? 3 : 6} key={index}>
                <Card sx={{ backgroundColor: "#242424", padding: 2 }}>
                  <Skeleton
                    width="60%"
                    height={20}
                    sx={{ mt: 1, background: "#fff" }}
                  />
                  <Skeleton
                    width="40%"
                    height={30}
                    sx={{ mt: 1, background: "#fff" }}
                  />
                </Card>
              </Grid>
            ))}
          </>
        ) : (
          data.map((item) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={isSuper ? 3 : 6}
              key={item.id}
            >
              <Card
                sx={{
                  backgroundColor: "#242424",
                  color: "white",
                  padding: 2,
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  border: "1px solid rgba(255, 224, 51, 0.20)",
                }}
              >
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{ color: "#999", fontWeight: 400, fontSize: 14 }}
                  >
                    {item.name}
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{ color: "#fff", fontWeight: 400, mt: 1, fontSize: 24 }}
                  >
                    {item.value}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    backgroundColor: "rgba(255, 215, 0, 0.20)",
                    padding: 1,
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={item.icon}
                    alt={item.name}
                    style={{ width: 24, height: 24 }}
                  />
                </Box>
              </Card>
            </Grid>
          ))
        )}
      </Grid>
    </React.Fragment>
  );
};
